import { render } from "./AuthView.vue?vue&type=template&id=479946c9"
import script from "./AuthView.vue?vue&type=script&lang=ts"
export * from "./AuthView.vue?vue&type=script&lang=ts"
script.render = render

export default script